// Imports MUI Components
import {  Box, 
          Button, 
          Stack,
          Typography, Link} from "@mui/material"

import Logo from "../../atoms/logo/Logo";

import "./styles.css"

const HeaderHoverableLogo = ({ }) => {
  return (
    <>
      <Link href={"/"}>
      <Box
        class="button"
        sx={{
          // border: "1px solid black",
          position: "relative",
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          cursor: "pointer",
        }}
      >

         <Stack
          direction="row"
          sx={{
            textAlign: "center",
            alignItems: "center",
          }}
        >
          
          <Logo
            src={require('../../../../assets/logo.png')}/>

          <Stack
            sx={{
              // opacity: 0,
              // visibility: "hidden",
              position: "absolute",
              left: "90%",
            }}
          >
            
            <Button
              type="text"
              class="button1">
                <span class="actual-text">&nbsp;VSDIAMOND&nbsp;</span>
                <span aria-hidden="true" class="hover-text">&nbsp;VSDIAMOND&nbsp;</span>
            </Button>

            <Button
              type="text"
              class="button2">
                <span class="actual-text">DENTAL&nbsp;CLINIC</span>
                <span aria-hidden="true" class="hover-text">DENTAL&nbsp;CLINIC</span>
           </Button>

          </Stack>
        </Stack>
      </Box>
      </Link>
    </>
  );
};

export default HeaderHoverableLogo;